export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Español'
  },
  'title': 'RETIRADA DEL MERCADO DE PRODUCTOS QUICKDRAWS SIMOND ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Retirada de producto. Información importante sobre su seguridad y equipo.',
    'purchaseWindow': 'Usted adquirió una cinta exprés de escalada ALPINISM y/o VERTIKA entre el 1 de enero de 2022 y el 23 de julio de 2026.',
    'skus': 'Cinta exprés Alpinism de 11 cm (4051175 / 8589547)\nCinta exprés Alpinism de 17 cm (4051176 / 8589548)\nPaquete de 5 cintas exprés Alpinism (4171656 / 8608405)\nCinta exprés Vertika de 11 cm (5499689 / 8935765)\nCinta exprés Vertika de 17 cm (5500194 / 8935909)',
    'responsibility': 'El diseño de equipos de protección individual implica una responsabilidad absoluta hacia quienes utilizan nuestros productos. Por ello, le informamos de la retirada del mercado de la cinta exprés equipada con el mosquetón Rocky Fil.',
    'defect': 'Hemos detectado un defecto en el remachado del cierre de alambre de algunos mosquetones. Este defecto de montaje puede provocar la rotura del cierre de alambre y el consiguiente riesgo de que el mosquetón se rompa en caso de caída.',
    'stopUsing': 'Como medida de precaución, le rogamos que deje de usar el producto inmediatamente y siga el procedimiento que se indica a continuación.'
  },
  'procedure': {
    'stopUsing': 'Por lo tanto, le pedimos que deje de usar este equipo de inmediato y verifique si su producto está afectado por este defecto siguiendo las instrucciones de solución de problemas que se indican a continuación.',
    'title': 'Verifique sus productos:',
    'intro': 'Verifique que ambos lados del cierre de alambre permanezcan bien sujetos al mosquetón:',
    'step1': 'Tome el mosquetón por un lado, coloque el pulgar entre los dos alambres (el pulgar más cercano al remache). Presione firmemente hacia abajo contra el mosquetón.',
    'step2': 'Gire el mosquetón y repita la misma acción en el otro lado del cierre de alambre.'
  },
  'outcome': {
    'nok': {
      'body': 'Tras la inspección, se ha detectado que el cable se ha soltado. Deje de usar el producto inmediatamente y diríjase a su tienda DECATHLON más cercana. Allí, nuestro equipo se encargará de su producto defectuoso y le reembolsará el importe total de inmediato.',
      'support': 'Si tiene alguna dificultad, nuestro equipo de atención al cliente está disponible para encontrar una solución a su medida y guiarle en todo momento: 0800 710 770, de lunes a sábado, de 9:00 a 19:00.'
    },
    'ok': {
      'body': 'Tras comprobar que el cable no se sale de su alojamiento, su producto no se ve afectado por este defecto y puede seguir utilizándolo con total tranquilidad.'
    }
  },
  'buttons': {
    'ok': 'Mi producto está bien.',
    'nok': 'Mi producto es NOK'
  }
} as const
